import {
  ApplicationConfig,
  inject,
  isDevMode,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideServiceWorker } from '@angular/service-worker';
import { routes } from './app.routes';

import { registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideNgcCookieConsent } from 'ngx-cookieconsent';
import { AnalyticsService } from './shared/services/analytics.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const gaService = inject(AnalyticsService);
      gaService.init();
    }),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideHttpClient(),
    provideIonicAngular({ mode: 'md', backButtonText: '' }),
    provideNgcCookieConsent({
      cookie: {
        domain: 'clima.rs.gov.br',
      },
      position: 'top',
      theme: 'classic',
      palette: {
        popup: {
          background: '#000000',
          text: '#ffffff',
          link: '#ffffff',
        },
        button: {
          background: '#f1d600',
          text: '#000000',
          border: 'transparent',
        },
      },
      type: 'info',
      content: {
        message:
          'Este site usa cookies para oferecer a você uma melhor experiência',
        dismiss: 'Entendi',
        deny: 'Recusar',
        link: 'Saiba mais',
        href: 'https://estado.rs.gov.br/aviso-de-cookies',
        policy: 'Cookie Policy',
      },
    }), provideCharts(withDefaultRegisterables()),
  ],
};
